import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { metricKeys } from '@pulse/metrics';
import sortBy from 'lodash/sortBy';
import { setSelectedKPI } from '@store/overviewDashboard/base/actions';
import {
  isIntervalGreaterThanADaySelector,
  kpiDimensionMetricsSelector,
  kpiMetricSelector,
} from '@store/overviewDashboard/base/selectors';
import { getMetricOvbDisplayName } from '@utils/metrics';
import { ovbDeviceMetricsEnabledSelector } from '@store/common/selectors';
import PrimarySelect from '@components/common/Select';

function KpiMetricsDropdown() {
  const dispatch = useDispatch();
  const selectedKpiMetric = useSelector(kpiMetricSelector);
  const showImpactedDevices = useSelector(ovbDeviceMetricsEnabledSelector);
  const isIntervalGreaterThanADay = useSelector(isIntervalGreaterThanADaySelector);
  const kpiMetrics: any = useSelector(kpiDimensionMetricsSelector);

  // update dimension
  const onChange = (value) => {
    dispatch(setSelectedKPI(value));
  };

  const { kpiMetricList } = useMemo(() => {
    const options: any[] = [];
    kpiMetrics.forEach((metricKey) => {
      // hide impacted devices if the metrics are disabled
      // or if the window is greater than 24h
      if (
        metricKey === metricKeys.BadUniqueDevices &&
        (!showImpactedDevices || isIntervalGreaterThanADay)
      ) {
        return;
      }

      const ovbDisplayName = getMetricOvbDisplayName({ metricKey });
      // build dropdown options
      options.push({
        value: metricKey,
        label: ovbDisplayName,
      });
    });

    return { kpiMetricList: sortBy(options, 'displayValue') };
  }, [selectedKpiMetric, showImpactedDevices, isIntervalGreaterThanADay]);

  return (
    <PrimarySelect
      showSearch
      optionFilterProp="label"
      options={kpiMetricList}
      onChange={onChange}
      value={selectedKpiMetric}
      styles={{ popup: { root: { minWidth: 250 } } }}
      style={{ width: 'fit-content', maxWidth: 380, minWidth: 100 }}
      variant="borderless"
      size="large"
    />
  );
}

export default KpiMetricsDropdown;
